import { datadogLogs } from "@datadog/browser-logs";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useRoundById } from "../../../context/RoundContext";
import { isDirectRound, isInfiniteDate } from "../../api/utils";
import NotFoundPage from "../../common/NotFoundPage";
import { Spinner } from "../../common/Spinner";
import { getAlloVersion } from "common/src/config";
import { RoundPage } from "./RoundPage";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function ViewRound() {
  datadogLogs.logger.info("====> Route: /round/:chainId/:roundId");
  datadogLogs.logger.info(`====> URL: ${window.location.href}`);
  const {
    chainId,
    roundId
  } = useParams();
  const {
    round,
    isLoading
  } = useRoundById(Number(chainId), roundId === null || roundId === void 0 ? void 0 : roundId.toLowerCase());
  const currentTime = new Date();
  const isBeforeRoundStartDate = round && (isDirectRound(round) ? round.applicationsStartTime : round.roundStartTime) >= currentTime;
  const isAfterRoundStartDate = round && (isDirectRound(round) ? round.applicationsStartTime : round.roundStartTime) <= currentTime;
  // covers infinte dates for roundEndDate
  const isAfterRoundEndDate = round && (isInfiniteDate(isDirectRound(round) ? round.applicationsEndTime : round.roundEndTime) ? false : round && (isDirectRound(round) ? round.applicationsEndTime : round.roundEndTime) <= currentTime);
  const isBeforeRoundEndDate = round && (isInfiniteDate(isDirectRound(round) ? round.applicationsEndTime : round.roundEndTime) || (isDirectRound(round) ? round.applicationsEndTime : round.roundEndTime) > currentTime);
  const alloVersion = getAlloVersion();
  useEffect(() => {
    if (isAfterRoundEndDate !== undefined && roundId !== null && roundId !== void 0 && roundId.startsWith("0x") && alloVersion === "allo-v2" && !isAfterRoundEndDate) {
      window.location.href = `https://explorer-v1.gitcoin.co${window.location.pathname}${window.location.hash}`;
    }
  }, [roundId, alloVersion, isAfterRoundEndDate]);
  return isLoading ? /*#__PURE__*/_jsx(Spinner, {
    text: "We're fetching the Round."
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: round && chainId && roundId ? /*#__PURE__*/_jsx(RoundPage, {
      round: round,
      chainId: Number(chainId),
      roundId: roundId,
      isBeforeRoundStartDate: isBeforeRoundStartDate,
      isAfterRoundStartDate: isAfterRoundStartDate,
      isBeforeRoundEndDate: isBeforeRoundEndDate,
      isAfterRoundEndDate: isAfterRoundEndDate
    }) : /*#__PURE__*/_jsx(NotFoundPage, {})
  });
}